/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
// import WasteDashboard from './WasteDashboard';
import { PageTitle } from '../../../_metronic/layout/core'
// import { TablesWidget9 } from '../../../_metronic/partials/widgets'
// import TryWid from '../../../_metronic/partials/widgets/mixed/TryWid'
import { TryWid } from '../../../_metronic/partials/widgets/mixed/TryWid'
import { TablesWidget9C } from '../../../_metronic/partials/widgets/tables/TablesWidget9C'
import {
  // ChartsWidget1,
  ListsWidget4,
  ListsWidget2,
  // ListsWidget6,
  // StatisticsWidget5,
  // StatisticsWidget6,
  TablesWidget10,
  // TablesWidget13,
  SankyWidget,
  ChartsWidget3,
  TablesWidget5,
  MixedWidget8,
  TablesWidget2,
} from '../../../_metronic/partials/widgets'
import { ChartsWidgetG } from '../../../_metronic/partials/widgets/charts/ChartsWidgetG'
import { ChartsWidgetG3 } from '../../../_metronic/partials/widgets/charts/ChartsWidgetG3'
import { ChartsWidgetG4 } from '../../../_metronic/partials/widgets/charts/ChartsWidgetG4'
import { MixedWidget7C222 } from '../../../_metronic/partials/widgets/mixed/MixedWidget7C222'

// import { MixedWidget7 } from '../../../_metronic/partials/widgets'
import MapComponent from '../../modules/apps/data-administration/data-admininstration-list/Map'
import MapComponentC from '../../modules/apps/data-administration/data-admininstration-list/Map copy'
import MapNew from '../../modules/apps/data-administration/data-admininstration-list/form-edit-modal/Map copy'
import { useQuery } from 'react-query'
import { getUserById } from '../../modules/apps/data-administration/data-admininstration-list/core/_requests'
// import { ChartsWidgetDonut } from '../../../_metronic/partials/widgets/charts/ChartsWidgetDonut'
import { useAuth } from '../../modules/auth'
// import { UsersListHeader } from '../../modules/apps/data-administration/data-admininstration-list/components/header/UsersListHeader'
import { useFetchCommon } from '../../../_metronic/helpers/crud-helper/useQuery'
import { generateYearOptions } from '../../modules/apps/data-administration/data-admininstration-list/invenotry/inventoryList'
import { useQueryRequest } from '../../modules/apps/data-administration/data-admininstration-list/core/QueryRequestProvider'
import { MixedWidget7C1 } from '../../../_metronic/partials/widgets/mixed/MixedWidget7C1'
import { MixedWidget7C2 } from '../../../_metronic/partials/widgets/mixed/MixedWidget7C2'

import { TablesWidget2Copy } from '../../../_metronic/partials/widgets/tables/TablesWidget2Copy'
// import { MixedWidget10 } from '../../../_metronic/partials/widgets'
import { MixedWidget10C } from '../../../_metronic/partials/widgets/mixed/MixedWidget10C'
import { ListsWidget2C } from '../../../_metronic/partials/widgets/lists/ListsWidget2C'
import { ChartsWidget3C } from '../../../_metronic/partials/widgets/charts/ChartsWidget3C'
// import { useState, useEffect } from 'react'
import axios from 'axios'
// import { Item1 } from '../../../_metronic/partials/content/activity/Item1'
// import { ActivityDrawer } from '../../../_metronic/partials'
import { CardsWidget6 } from '../../../_metronic/partials/content/cards/Card6'
import { CardsWidget17 } from '../../../_metronic/partials/content/cards/Card7'
import { MixedWidget10 } from '../../../_metronic/partials/widgets'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import StatsCard from './StatsCard'
import { TablesWidget18 } from '../../../_metronic/partials/widgets/tables/TablesWidget18'

import { ChartsWidget1 } from '../../../_metronic/partials/widgets'

import { MixedWidget11 } from '../../../_metronic/partials/widgets'
import { TablesWidget19 } from '../../../_metronic/partials/widgets/tables/TablesWidget19'

import { ChartsWidget10 } from '../../../_metronic/partials/widgets/charts/ChartsWidget10'

import { ChartsWidget7 } from '../../../_metronic/partials/widgets'
// import { ChartsWidget8 } from '../../../_metronic/partials/widgets'
import StatsCard2 from '../../modules/apps/data-administration/data-admininstration-list/leaderboard/StatsCards2'
// import { CombinedPlasticChart } from '../../../_metronic/partials/widgets'
import { SupplyChainGrowthChart } from '../../../_metronic/partials/widgets/charts/CombinedPlasticChart'
import AverageDailySalesCard from './AverageDailySalesCard'
import RecentOrders from './RecentOrders'

const DashboardPage = ({ year = '' }: any) => {
  const { isFranchise, currentUser, auth, isSupplyChainManager }: any = useAuth()




  // const { responseData: impact } = useFetchCommon({
  //   api: `impact`,
  //   isEnabled: true,
  //   isDropDown: false,
  // })

  const { responseData: impact } = useFetchCommon({
    api: `impact`,
    isEnabled: currentUser.userType !== "CLIENT",
    isDropDown: false,
  })

  // const { responseData: top5Staff } = useFetchCommon({
  //   api: `franchise/topAppUser/${currentUser.id}`,
  //   isEnabled: true,
  //   isDropDown: false,
  // })

  // const { responseData: newMapData } = useFetchCommon({
  //   api: `users?page=0&size=10&type=WASTE_SOURCE`,
  //   isEnabled: true,
  //   isDropDown: false,
  // })

  // First, get the franchiseId from localStorage
  const getFranchiseId = () => {
    try {
      const authData = localStorage.getItem('kt-auth-react-v')
      if (authData) {
        const parsedData = JSON.parse(authData)
        return parsedData.data?.franchiseeid || parsedData.data?.franchiseId || null
      }
      return null
    } catch (error) {
      console.error('Error getting franchise ID:', error)
      return null
    }
  }

  const franchiseId = getFranchiseId()

  // Then use it in useFetchCommon
  const { responseData: performanceResponseData } = useFetchCommon({
    api: `franchise/performance/${franchiseId}`,
    label: ['personalDetails', 'name'],
    isDropDown: false,
    isEnabled: isSupplyChainManager,
  })




  const { updateState, state } = useQueryRequest()

  const { responseData: characteristics } = useFetchCommon({
    api: `characterstics/analytics?year=${new Date().getUTCFullYear()}`,
    label: ['personalDetails', 'name'],
    isDropDown: true,
    // isEnabled: isSupplyChainManager,
  })

  const { responseData: productionResponseData } = useFetchCommon({
    api: `admin/production/analytics?year=${new Date().getUTCFullYear()}`,
    label: ['personalDetails', 'name'],
    isDropDown: false,
    isEnabled: isSupplyChainManager,
  })


  const userType = 'CUSTOMER'; // or pass as prop/state
  const yearThis = 2025;

  // const { responseData: newSuppliers } = useFetchCommon({
  //   api: `monthlyUserCounts?year=${yearThis}`,
  //   isDropDown: false,
  //   isEnabled: isSupplyChainManager,
  // })


  const { data = {} } = useQuery(
    `admin/dashboard?year=${new Date().getUTCFullYear()}`,
    () => getUserById('', `admin/dashboard?year=${new Date().getUTCFullYear()}`),
    {
      cacheTime: 0,
      onError: (err) => {
        console.warn(err)
      },
    }
  )



  // console.log("heyyyyy this is data ,,,,,,,,,,,,,,,,", data)


  // const { data: analyticsData = {} } = useQuery(
  //   `admin/pickupPoints/analytics`,
  //   () => getUserById('', 'admin/pickupPoints/analytics'),
  //   {
  //     cacheTime: 0,
  //     onError: (err) => {
  //       console.warn(err)
  //     },
  //   }
  // )














































  // const { data: cleanUpData = {} } = useQuery(
  //   `collect/orders?page=0&size=10&wasteSource=C2B`,
  //   () => getUserById('', 'collect/orders?page=0&size=10&wasteSource=C2B'),
  //   {
  //     cacheTime: 0,
  //     onError: (err) => {
  //       console.warn(err)
  //     },
  //   }
  // )

  // const { data: dispatchData = {} } = useQuery(
  //   `convert/orders?page=0&size=10`,
  //   () => getUserById('', 'convert/orders?page=0&size=10'),
  //   {
  //     cacheTime: 0,
  //     onError: (err) => {
  //       console.warn(err)
  //     },
  //   }
  // )


  const { data: franchiseData } = useQuery(
    `users?page=0&size=10&type=FRANCHISE`,
    () => getUserById('', 'users?page=0&size=10&type=FRANCHISE'),
    {
      // enabled: isSponsor,
      enabled: false,
      cacheTime: 0,
      onError: (err) => {
        console.warn(err)
      },
    }
  )


  const [topAppUsers, setTopAppUsers] = useState<any>({ data: [] })
  const fetchTopAppUsers = async () => {
    try {
      const authData = localStorage.getItem('kt-auth-react-v');
      const authToken = authData ? JSON.parse(authData).data?.token : null;
      const franchiseId = authData ? JSON.parse(authData).data?.franchiseId : null;

      if (!authToken || !franchiseId) return;

      const response = await fetch(
        `${process.env.REACT_APP_BASE_API_URL}franchise/topAppUser/${franchiseId}?page=0&size=10`,
        {
          headers: {
            'Authorization': authToken,
            'Content-Type': 'application/json'
          }
        }
      );

      const data = await response.json();
      setTopAppUsers(data);
      return data;
    } catch (error) {
      console.error('Error fetching top app users:', error);
    }
  };
  useEffect(() => {
    fetchTopAppUsers();
  }, []);

  const [monthlyUserCounts, setMonthlyUserCounts] = useState<any>(null)
  const [monthlyConverterCounts, setMonthlyConverterCounts] = useState<any>(null)
  useEffect(() => {
    const fetchData = async () => {
      try {
        // First API call (without subType)
        const userCountsResponse = await axios.get(
          // `${process.env.REACT_APP_BASE_API_URL}monthlyUserCounts?userType=PICKUP_POINT&year=2025`
          `${process.env.REACT_APP_BASE_API_URL}monthlyUserCounts?year=${new Date().getFullYear()}`
        )
        setMonthlyUserCounts(userCountsResponse.data)
        // Second API call (with subType)
        // const converterCountsResponse = await axios.get(
        //   `${process.env.REACT_APP_BASE_API_URL}monthlyUserCounts?userType=PICKUP_POINT&year=2025&subType=CONVERTER`
        // )
        // setMonthlyConverterCounts(converterCountsResponse.data)
      } catch (error) {
        console.error('Error fetching monthly counts:', error)
      }
    }

    fetchData()
  }, [])



  const [data2, setData2] = useState([])
  const [loading, setLoading] = useState(true)

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}convert/orders?page=0&size=50`)
  //       const result = await response.json()
  //       setData2(result?.data || result || [])
  //       setLoading(false)
  //     } catch (error) {
  //       console.error('Error fetching data:', error)
  //       setLoading(false)
  //     }
  //   }

  //   fetchData()
  // }, [])


  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       // Get token from localStorage
  //       const authData = localStorage.getItem('kt-auth-react-v')
  //       const token = authData ? JSON.parse(authData).data.token : null

  //       const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}convert/orders?page=0&size=50`, {
  //         headers: {
  //           'Authorization': `Bearer ${token}`,
  //           'Content-Type': 'application/json'
  //         }
  //       })
  //       const result = await response.json()

  //       // Access the data array correctly
  //       setData2(result.data || [])
  //       setLoading(false)
  //     } catch (error) {
  //       console.error('Error fetching data:', error)
  //       setLoading(false)
  //     }
  //   }

  //   fetchData()
  // }, [])






  const [categoriesList, setCategoriesList] = useState([{ label: 'Select one', value: '' }])
  useEffect(() => {
    if (data && data.length) {
      let dropdownData: any = [{ label: 'Select one', value: '' }]
      data.map((eachData) => {
        return dropdownData.push({ label: eachData?.personalDetails?.name, value: eachData.id })
      })
      setCategoriesList(dropdownData)
      // updateState({
      //   enabled: true,
      //   initialApi: `categories/${dropdownData[0].value}/items`,
      //   ...initialQueryState,
      // })
    }
  }, [data])

  // useEffect(() => {
  //   if (analyticsData.length) {
  //     const transformedData: any = []

  //     const properties = Object.keys(analyticsData[0]).filter(
  //       (key) =>
  //         key !== 'pickupPointId' &&
  //         key !== 'pickupPointName' &&
  //         key !== 'pickupPointAddress' &&
  //         key !== 'percentageCapacityDiverted' &&
  //         key !== 'percentageAudited'
  //     )
  //     properties.forEach((property) => {
  //       // const dataValues = analyticsData?.map((obj) =>
  //       //   Array.isArray(obj[property]) ? '' : parseFloat(obj[property]?.toFixed(2))
  //       // )
  //       const dataValues = analyticsData?.map((obj) =>
  //         Array.isArray(obj[property]) ? 0 : parseFloat(obj[property]) || 0
  //       )
  //       transformedData.push({
  //         name: property,
  //         data: dataValues,
  //       })
  //     })
  //     const collectionPointName = analyticsData.map((obj) => obj.pickupPointName)
  //     // setleaderBoardXaxisData(collectionPointName)
  //     // setleaderBoardYaxisData(transformedData)
  //   }
  // }, [analyticsData])

  const [mapLocation, setMapLocation] = useState<any>([])
  const [newMapLocation, setNewMapLocation] = useState<any>([])
  const [newDataMapLocation, setDatanewMapLocation] = useState<any>([])




  const { pickupPoints, customers, collectTrend, productionTrend, suppliedTrend, monthlyCollectionTrend, monthlyRecyclingTrend, monthlySaleTrend } = data
  useEffect(() => {
    if (pickupPoints?.length) {
      const modifyData = pickupPoints.map((x) => {
        return {
          position: {
            lat: x.latitude,
            lng: x.longitude,
          },
          name: x.name,
          id: x.id
        }
      })
      setMapLocation(modifyData)
    }
  }, [pickupPoints])





  // useEffect(() => {
  //   if (newMapData?.length) {
  //     const newMapModify = newMapData.map((x) => {
  //       // return {
  //       //   position: {
  //       //     lat: x?.address?.latitute,
  //       //     lng: x?.address?.longitute,
  //       //   },
  //       //   name: x?.address?.city,
  //       //   id: x.id
  //       // }
  //       return {
  //         position: {
  //           lat: x?.address?.latitute,
  //           lng: x?.address?.longitute,
  //         },
  //         name: x?.personalDetails?.name || x?.address?.city, // Use actual name
  //         id: x.id,
  //         kycDocument: x.kycDocument || [],
  //         totalDepositedQuantity: x.totalDepositedQuantity || 0,
  //         isCustomer: true // Add explicit flag
  //       }
  //     })
  //     setNewMapLocation(newMapModify)
  //   }
  // }, [newMapData])

  useEffect(() => {
    if (mapLocation.length || newMapLocation.length) {
      setDatanewMapLocation([...mapLocation, ...newMapLocation])
    }
  }, [mapLocation, newMapLocation])

  const [collectedGraphData, setCollectedGraphData] = useState<any>({})
  const [suppliedGraphData, setSuppliedGraphData] = useState<any>({})
  const [processGraphData, setProcessGraphData] = useState<any>({})

  const updateGraphData2 = (trendData, setGraphData, graphData) => {
    if (trendData && Object.keys(trendData)?.length > 0) {
      const label = Object.keys(trendData).map((date) => {
        const [year, month, day] = date.split('-') // Split the date string
        return `${month}-${day}` // Format as "day-month"
      })
      // const data = Object.values(trendData)
      // const data = Object.values(trendData)?.map((value: any) => parseFloat(value).toFixed(2))
      const data = Object.values(trendData)?.map((value: any) => parseFloat(value) || 0)
      setGraphData({ ...graphData, label, data })
    }
  }
  const { responseData: sankey4 } = useFetchCommon({
    api: `sankey/franchise${isSupplyChainManager
      ? `/${auth.data.franchiseId}`
      : currentUser.id
        ? `/${currentUser.id}`
        : ''
      }`,
    isEnabled: isFranchise || isSupplyChainManager,
    isDropDown: false,
  })

  useEffect(() => {
    updateGraphData2(collectTrend, setCollectedGraphData, collectedGraphData)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [collectTrend])

  useEffect(() => {
    updateGraphData2(productionTrend, setProcessGraphData, processGraphData)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productionTrend])

  useEffect(() => {
    updateGraphData2(suppliedTrend, setSuppliedGraphData, suppliedGraphData)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [suppliedTrend])

  const numberItems = [
    // {
    //   value: 'processed',
    //   name: 'Material processed',
    //   icon: 'emission',
    //   color: '#ffffff',
    // },
    // {
    //   value: 'inTransitSupply',
    //   name: 'In transit',
    //   icon: 'Customer',
    //   color: '#ffffff',
    // },
    // { value: 'collected', name: 'Material collected', icon: 'Collected', color: '#ffffff' },
    { value: 'stock', name: 'Stock', icon: 'stock-new', color: '#ffffff' },
    // {
    //   value: 'received',
    //   name: 'Material transfer',
    //   icon: 'Production',
    //   color: '#ffffff',
    // },
    // {
    //   value: 'externalSale',
    //   name: 'Material sold to End Users',
    //   icon: 'Dispatched',
    //   color: '#ffffff',
    // },


    // {
    //   value: 'diversionProductionQuantity',
    //   name: 'Material recycled',
    //   icon: 'waste diverter',
    //   color: '#ffffff',
    // },
    // { value: 'wastage', name: 'Process loss', icon: 'process loss', color: '#ffffff' },

  ]

  console.log("monthlyCollectionTrend", monthlyCollectionTrend)






















  // Replace the existing useEffects with these two:

  // 1. Handle pickup points from dashboard
  useEffect(() => {
    console.log("useEffect RUNNING!");
    console.log("pickupPoints?.length:", pickupPoints?.length);
    console.log("customers?.length:", customers?.length);

    if (pickupPoints?.length || customers?.length) {
      console.log("Inside IF condition");

      // Map pickup points
      const pickupPointsData = pickupPoints?.map((x) => {
        return {
          position: {
            lat: x.latitude,
            lng: x.longitude,
          },
          name: x.name,
          id: x.id,
          isCustomer: false
        }
      }) || []

      console.log("pickupPointsData:", pickupPointsData);

      // Map customers
      const customersData = customers?.map((x) => {
        return {
          position: {
            lat: x.latitude,
            lng: x.longitude,
          },
          name: x.name,
          id: x.id,
          isCustomer: true,
          kycDocument: x.kycDocument,
          totalDepositedQuantity: x.totalDepositedQuantity,
          customerType: x.customerType || ''
        }
      }) || []

      console.log("customersData:", customersData);

      // Combine both
      const combined = [...pickupPointsData, ...customersData];
      console.log("Combined data being set to mapLocation:", combined);
      setMapLocation(combined)
    } else {
      console.log("IF condition FALSE - no data");
    }
  }, [pickupPoints, customers])

  // This is the SECOND useEffect - keep it as is
  useEffect(() => {
    console.log("=== Second useEffect ===");
    console.log("mapLocation:", mapLocation);
    console.log("newMapLocation:", newMapLocation);

    if (mapLocation.length || newMapLocation.length) {
      console.log("Setting newDataMapLocation to:", [...mapLocation, ...newMapLocation]);
      setDatanewMapLocation([...mapLocation, ...newMapLocation])
    }
  }, [mapLocation, newMapLocation])

  // 2. Handle customers from dashboard 




  // useEffect(() => {
  //   if (data?.customers?.length) {
  //     const customerMapData = data.customers
  //       .filter((customer) => customer.latitude !== 0 && customer.longitude !== 0) 
  //       .map((customer) => {
  //         return {
  //           position: {
  //             lat: customer.latitude,
  //             lng: customer.longitude,
  //           },
  //           name: customer.name,
  //           id: customer.id,
  //           kycDocument: customer.kycDocument || [],
  //           totalDepositedQuantity: customer.totalDepositedQuantity || 0,
  //           isCustomer: true
  //         }
  //       })
  //     setNewMapLocation(customerMapData)
  //   }
  // }, [data]) 

  useEffect(() => {
    if (data?.customers?.length) {
      const customerMapData = data.customers
        .filter((customer) => customer.latitude !== 0 && customer.longitude !== 0)
        .map((customer) => {
          return {
            position: {
              lat: customer.latitude,
              lng: customer.longitude,
            },
            name: customer.name,
            id: customer.id,
            kycDocument: customer.kycDocument || [],
            totalDepositedQuantity: customer.totalDepositedQuantity || 0,
            customerType: customer.customerType,
            mobile: customer.mobile,
            address: customer.address,
            isCustomer: true
          }
        })
      setNewMapLocation(customerMapData)
    }
  }, [data])




  // 3. Keep the combining logic
  useEffect(() => {
    if (mapLocation.length || newMapLocation.length) {
      setDatanewMapLocation([...mapLocation, ...newMapLocation])
    }
  }, [mapLocation, newMapLocation])




  const customerData = monthlyUserCounts?.data?.find(item => item.userType === "CUSTOMER");
  const pickupPointData = monthlyUserCounts?.data?.find(item => item.userType === "PICKUP_POINT");
  const sponsorData = monthlyUserCounts?.data?.find(item => item.userType === "SPONSOR");
  const converterData = monthlyUserCounts?.data?.find(item => item.userType === "CONVERTER");
  // const customerData = monthlyUserCounts?.data?.find(item => item.userType === "CUSTOMER");
  // const pickupPointData = monthlyUserCounts?.data?.find(item => item.userType === "PICKUP_POINT");

  return (
    <>
      {/* <div className='row g-xl-4' style={{ marginBottom: '20px' }}>
        {numberItems.map((eachitems, eachIndex) => (
          <div key={eachIndex + 1 + ''} className='col-xl-3'>
            <StatisticsWidget5
              className='card-xl-stretch mb-xl-8'
              img={eachitems.icon}
              color={eachitems.color || 'warning'}
              iconColor='primary'
              title={`
             ${data[eachitems.value]?.toFixed(
                [
                  'collectionPoints',
                  'diversionFacilities',
                  'wasteDiverters',
                  'lifeImpacted',
                ].includes(eachitems.value)
                  ? 0
                  : 2
              ) || ''
                }
             ${['diversionFacilities', 'wasteDiverters', 'lifeImpacted', 'wastage'].includes(
                  eachitems.value
                )
                  ? ''
                  : ' kg'
                }
           `}
              description={eachitems.name}
            />
          </div>
        ))}
      </div> */}


      {(currentUser?.userType === "CLIENT" || currentUser?.userType === "FRANCHISE_USER"
        || currentUser?.userType === "MARKETING" || currentUser?.userType === "CLIENT_USER"
      ) && (
          <div className='row mt-5'>
            <div className='col-md-3 col-lg-3 col-xl-3 col-xxl-3 d-flex'>
              {/* <CardsWidget6
                activePercentage={Math.round((data?.participationRate || 0) * 100)}
                count={data.customerCount}
                className='w-100'
                description={currentUser?.companyDetails?.contactName}
                color='#F1416C'
                img={toAbsoluteUrl('/media/patterns/vector-1.png')}
              /> */}



              <StatsCard2
                className='w-100'
                targetCustomerCount={data?.customerCount}
                actualCustomerCount={data?.activeCustomers}
                householdpercentage={Math.round((data?.participationRate || 0) * 100)}
                redirectLink={"apps/waste-source/waste-collector"}
              />


            </div>
            <div className='col-md-3 col-lg-3 col-xl-3 col-xxl-3 d-flex'>
              <CardsWidget17 className='w-100' lifetimeCollection={Math.round(data?.lifeTimeCollected || 0)}
                recyclable={+Math.round(data?.materialAnalytics?.breakup?.find(item => item.categoryName === "RECYCLABLE")?.currentYearWeight || 0)}
                nonRecyclable={+Math.round(data?.materialAnalytics?.breakup?.find(item => item.categoryName === "NON RECYCLABLE")?.currentYearWeight || 0)} />
            </div>
            <div className='col-md-6 col-lg-6 col-xl-6 col-xxl-6 d-flex'>
              {/* <MixedWidget10C
              chartHeight='130px'
              className='w-100'
              chartColor='info'
              title="Plastic prevented"
              subtitle="Plastic prevented from waste suppliers"
              amount={`${(data?.lifeTimeCollected || 0).toFixed(2)} kg`}
              chartData={data.yearlyCollected}
              lineColor='#ed6e43'
              fillColor='#ffdccf'
            /> */}



              {/* <MixedWidget11
              data={data?.yearlyCollected ? (() => {
                const startYear = 2025;
                const endYear = 2035;
                const years: string[] = [];
                const values: number[] = [];

                for (let year = startYear; year <= endYear; year++) {
                  years.push(year.toString());
                  values.push(data.yearlyCollected[year] || 0);
                }

                return {
                  series1: values,
                  series2: [],
                  categories: years
                };
              })() : undefined}
              className='w-100'
              chartColor='primary'
              chartHeight='150px'
              title='Impact'
              subtitle='Plastic prevented & Household connected'
              amount={`${(data?.lifeTimeCollected || 0).toFixed(2)} kg`}
            /> */}

              <MixedWidget11
                data={data?.yearlyCollected ? (() => {
                  const startYear = new Date().getFullYear() - 2;
                  const endYear = startYear + 5;
                  const years: string[] = [];
                  const plasticValues: number[] = [];
                  const householdValues: number[] = [];

                  for (let year = startYear; year <= endYear; year++) {
                    years.push(year.toString());
                    plasticValues.push(data.yearlyCollected[year] || 0);
                    householdValues.push(data.yearlyHouseholds[year] || 0);
                  }

                  return {
                    series1: plasticValues,
                    series2: householdValues,
                    categories: years
                  };
                })() : undefined}
                className='w-100'
                chartColor='primary'
                chartHeight='250px'
                title='Impact'
                subtitle='Plastic prevented & Households connected'
                amount={`${(data?.lifeTimeCollected || 0)?.toLocaleString('en', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })} kg`}
              />
            </div>
          </div>
        )}


      {/* {currentUser?.userType === "CLIENT" && (
      <div className='row mt-5'>
        <div className="col-4">
          <MixedWidget10C
            className=''
            chartColor='info'
            chartHeight='150px'
            title="Household"
            subtitle="No. of Household added in a month"
            amount={``}
            chartData={monthlyCollectionTrend}
            lineColor='#ed6e43'
            fillColor='#ffdccf'
          />
        </div>
        <div className="col-4">
          <MixedWidget10C
            className=''
            chartColor='warning'
            chartHeight='150px'
            title="Collection points"
              subtitle="No. of Collection points added in a month"
            amount={``}
            chartData={monthlyRecyclingTrend}
            lineColor='#f4b7f9'
            fillColor='#f1e4eb'
          />
        </div>
        <div className="col-4">
          <MixedWidget10C
            className=''
            chartColor='primary'
            chartHeight='150px'
            title="Impact Partner"
              subtitle="No. of Impact Partner added in a month"
            amount={``}
            chartData={monthlySaleTrend}
            lineColor='#4f45f5'
            fillColor='#dfdbff'
          />
        </div>
      </div>
      )} */}

      {(currentUser?.userType === "CLIENT" || currentUser?.userType === "CLIENT_USER" || currentUser?.userType === "MARKETING") && (
        <div className='row mt-5'>
          <div className="col-4">
            <MixedWidget10C
              className=''
              chartColor='info'
              chartHeight='150px'
              title="Households"
              subtitle="No. of households added in a month"
              amount={customerData?.totalUsers || 0}
              chartData={customerData?.monthlyCounts || {}}
              lineColor='#ed6e43'
              fillColor='#ffdccf'
            />
          </div>
          <div className="col-4">
            <MixedWidget10C
              className=''
              chartColor='warning'
              chartHeight='150px'
              title="Material Hubs"
              subtitle="No. of Material Hubs added in a month"
              amount={pickupPointData?.totalUsers || 0}
              chartData={pickupPointData?.monthlyCounts || {}}
              lineColor='#ffe500'
              fillColor='#fef7dc'
            />
          </div>
          <div className="col-4">
            <MixedWidget10C
              className=''
              chartColor='primary'
              chartHeight='150px'
              title="Impact Partners"
              subtitle="No. of Impact Partners added in a month"
              amount={sponsorData?.totalUsers || 0}
              chartData={sponsorData?.monthlyCounts || {}}
              lineColor='#4f45f5'
              fillColor='#dfdbff'
            />
          </div>
        </div>
      )}



      {newDataMapLocation?.length && currentUser.userType !== "FRANCHISE_USER" && (
        <div style={{ marginTop: "20px" }}>
          {/* <MapComponent data={newDataMapLocation || []} zooms={12} /> */}
          <MapComponentC data={newDataMapLocation || []} zooms={12} />
        </div>
      )}

      {(currentUser?.userType === "CLIENT" || currentUser?.userType === "CLIENT_USER" || currentUser?.userType === "MARKETING") && (
        <>
          {/* <div style={{ marginTop: "20px" }}>
            <TablesWidget18 className='mb-5 mb-xl-8' data={data} />
          </div> */}
          <div className="row" style={{ marginTop: '20px' }}>
            <div className="col-4">
              <MixedWidget10C
                className='card-xl-stretch mb-xl-8'
                chartColor='info'
                chartHeight='150px'
                title="Plastic prevented"
                subtitle="Quantity collected from Plastic Keepers"
                amount={`${(data?.collected || 0)?.toLocaleString('en', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })} kg`}
                chartData={monthlyCollectionTrend}
                lineColor='#ed6e43'
                fillColor='#ffdccf'
              />
            </div>
            <div className="col-4">
              <MixedWidget10C
                className='card-xl-stretch mb-xl-8'
                chartColor='warning'
                chartHeight='150px'
                title="Plastic recycled"
                subtitle="Quantity converted into recycled products"
                amount={`${(data?.diversionProductionQuantity || 0)?.toLocaleString('en', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })} kg`}
                chartData={monthlyRecyclingTrend}
                lineColor='#ffe500'
                fillColor='#ffe50033'
              />
            </div>
            <div className="col-4">
              <MixedWidget10C
                className='card-xl-stretch mb-5 mb-xl-8'
                chartColor='primary'
                chartHeight='150px'
                title="Plastic sold"
                subtitle="Quantity of plastic in circular economy"
                amount={`${(data?.externalSale || 0)?.toLocaleString('en', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })} kg`}
                chartData={monthlySaleTrend}
                lineColor='#4f45f5'
                fillColor='#dfdbff'
              />
            </div>
          </div>
        </>
      )}

      {/* <div style={{ display: 'flex', justifyContent: 'space-between', margin: '10px 0' }}>
        <div style={{
          margin: '10px',
          padding: '16px',
          borderRadius: '8px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          backgroundColor: '#ffffff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'start', 
          flex: 1
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',      
            justifyContent: 'center'
          }}>
            <div style={{
              width: '48px',
              height: '48px',
              borderRadius: '50%',
              backgroundColor: '#fae8fb',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: '16px',
              fontSize: '20px',
              fontWeight: 'bold',
              color: '#1a1a1a'
            }}>
              <img src="/media/svg/dashboard/New/recycling capacity.png" alt="" style={{ width: '27px', height: '27px' }}></img>
            </div>

            <div style={{ textAlign: 'left' }}>
              <div style={{ fontSize: '16px', fontWeight: '400' }}>
                {currentUser?.userType === 'FRANCHISE_USER' || currentUser?.userType === 'CLIENT'
                  ? 'Manufacturing capacity (MT)'
                  : 'Recycling capacity (MT)'}
              </div>

              <div style={{ fontSize: '24px', fontWeight: '700' }}>
                {data?.diversionCapacities || ''}
              </div>
            </div>
          </div>
        </div>








        <div style={{
          margin: '10px',
          padding: '16px',
          borderRadius: '8px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          backgroundColor: '#ffffff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'start', 
          flex: 1
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',      
            justifyContent: 'center'
          }}>
            <div style={{
              width: '48px',
              height: '48px',
              borderRadius: '50%',
              backgroundColor: '#fad9cc',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: '16px',
              fontSize: '20px',
              fontWeight: 'bold',
              color: '#1a1a1a'
            }}>
              <img src="/media/svg/dashboard/New/recycling factory.png" alt="" style={{ width: '27px', height: '27px' }}></img>
            </div>

            <div style={{ textAlign: 'left' }}>
              <div style={{ fontSize: '16px', fontWeight: '400' }}>Recycling facility</div>
              <div style={{ fontSize: '24px', fontWeight: '700' }}>
                {data?.diversionFacilities || ''}
              </div>
            </div>
          </div>
        </div>







        <div style={{
          margin: '10px',
          padding: '16px',
          borderRadius: '8px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          backgroundColor: '#ffffff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'start', 
          flex: 1
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',     
            justifyContent: 'center'
          }}>
            <div style={{
              width: '48px',
              height: '48px',
              borderRadius: '50%',
              backgroundColor: '#fee9c0',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: '16px',
              fontSize: '20px',
              fontWeight: 'bold',
              color: '#1a1a1a'
            }}>

              <img src="/media/svg/dashboard/New/waste supplier.png" alt="" style={{ width: '27px', height: '27px' }}></img>

            </div>

            <div style={{ textAlign: 'left' }}>
              <div style={{ fontSize: '16px', fontWeight: '400' }}>Waste suppliers</div>
              <div style={{ fontSize: '24px', fontWeight: '700' }}>
                {data?.lifeImpacted || ''}
              </div>
            </div>
          </div>
        </div>


        <div style={{
          margin: '10px',
          padding: '16px',
          borderRadius: '8px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          backgroundColor: '#ffffff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'start', 
          flex: 1
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',       
            justifyContent: 'center'
          }}>
            <div style={{
              width: '48px',
              height: '48px',
              borderRadius: '50%',
              backgroundColor: '#f5f3fe',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: '16px',
              fontSize: '20px',
              fontWeight: 'bold',
              color: '#1a1a1a'
            }}>
              <img src="/media/svg/dashboard/New/Facilities.png" alt="" style={{ width: '27px', height: '27px' }}></img>
            </div>

            <div style={{ textAlign: 'left' }}>
              <div style={{ fontSize: '16px', fontWeight: '400' }}>Supply chain facilities</div>
              <div style={{ fontSize: '24px', fontWeight: '700' }}>
                {data?.collectionPoints || ''}
              </div>
            </div>
          </div>
        </div>



      </div> */}

      {currentUser?.userType === "CLIENT" && false && (
        <div style={{ display: 'flex', justifyContent: 'space-between', margin: '' }}>
          <StatsCard
            icon="/media/svg/dashboard/New/recycling capacity.png"
            backgroundColor="#fae8fb"
            title={currentUser?.userType === 'FRANCHISE_USER' || currentUser?.userType === 'CLIENT'
              ? 'Manufacturing capacity (MT)'
              : 'Recycling capacity (MT)'}
            value={data?.diversionCapacities}
          />

          <StatsCard
            icon="/media/svg/dashboard/New/recycling factory.png"
            backgroundColor="#fad9cc"
            title="Recycling facility"
            value={data?.diversionFacilities}
          />

          <StatsCard
            icon="/media/svg/dashboard/New/waste supplier.png"
            backgroundColor="#fee9c0"
            title="Plastic Keepers"
            value={data?.lifeImpacted}
          />

          <StatsCard
            icon="/media/svg/dashboard/New/Facilities.png"
            backgroundColor="#f5f3fe"
            title="Material Hubs"
            value={data?.collectionPoints}
          />
        </div>
      )}


      {/* {(currentUser.userType === "PICKUP_POINT_STAFF" || currentUser.userType === "FRANCHISE_USER") && (
        <div className="row">
          <div className="col-4">
            <MixedWidget10C
              className='card-xl-stretch mb-xl-8'
              chartColor='info'
              chartHeight='150px'
              title="Material inwards"
              subtitle="Quantity collected from waste suppliers"
              amount={`${data?.collected?.toFixed(2) || '0'} kg`}
              chartData={monthlyCollectionTrend}
            />
          </div>
          <div className="col-4">
            <MixedWidget10C
              className='card-xl-stretch mb-xl-8'
              chartColor='warning'
              chartHeight='150px'
              title="Material recycled"
              subtitle="Quantity converted into recycled products"
              amount={`${data?.diversionProductionQuantity?.toFixed(2) || '0'} kg`}
              chartData={monthlyRecyclingTrend}
            />
          </div>
          <div className="col-4">
            <MixedWidget10C
              className='card-xl-stretch mb-5 mb-xl-8'
              chartColor='primary'
              chartHeight='150px'
              title="Material sold"
              subtitle="Quantity converted into recycled products"
              amount={`${data?.externalSale?.toFixed(2) || '0'} kg`}
              chartData={monthlySaleTrend}
            />
          </div>
          <div className="col-4">
            <MixedWidget10C
              className='card-xl-stretch mb-5 mb-xl-8'
              chartColor='primary'
              chartHeight='150px'
              title="Material sold"
              subtitle="Quantity converted into recycled products"
              amount={`${data?.externalSale?.toFixed(2) || '0'} kg`}
              chartData={monthlySaleTrend}
            />
          </div>
        </div>
      )} */}




      {(currentUser.userType === "PICKUP_POINT_STAFF" || currentUser.userType === "FRANCHISE_USER") && (
        <div className="row" style={{
          marginTop: currentUser?.userType === 'FRANCHISE_USER' ? '25px' : '0',
          marginBottom: '-20px'
        }}>
          <div className="col-4">
            <MixedWidget10C
              className='card-xl-stretch mb-xl-8'
              chartColor='info'
              chartHeight='150px'
              title="Plastic prevented"
              subtitle="Quantity collected from waste suppliers"
              amount={`${data?.collected?.toLocaleString('en', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }) || '0'} kg`}
              chartData={monthlyCollectionTrend}
              lineColor='#ed6e43'
              fillColor='#ffdccf'
            />
          </div>
          <div className="col-4">
            <MixedWidget10C
              className='card-xl-stretch mb-xl-8'
              chartColor='warning'
              chartHeight='150px'
              title="Plastic recycled"
              subtitle="Quantity converted into recycled products"
              amount={`${data?.diversionProductionQuantity?.toLocaleString('en', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }) || '0'} kg`}
              chartData={monthlyRecyclingTrend}
              lineColor='#ffe500'
              fillColor='#ffe50033'
            />
          </div>
          <div className="col-4">
            <MixedWidget10C
              className='card-xl-stretch mb-5 mb-xl-8'
              chartColor='primary'
              chartHeight='150px'
              title="Plastic sold"
              subtitle="Quantity converted into recycled products"
              amount={`${data?.externalSale?.toLocaleString('en', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }) || '0'} kg`}
              chartData={monthlySaleTrend}
              lineColor='#4f45f5'
              fillColor='#dfdbff'
            />
          </div>
        </div>
      )}

      {/* 

      {(newDataMapLocation?.length && (
        <div>
          <MapComponentC data={newDataMapLocation || []} zooms={12} />
        </div>
      )) ||
        null} */}



      {newDataMapLocation?.length && currentUser.userType === "FRANCHISE_USER" && (
        <div style={{ marginTop: "20px" }}>
          {/* <MapNew data={newDataMapLocation || []} zooms={12} /> */}
          <MapComponentC data={newDataMapLocation || []} zooms={12} />
        </div>
      )}




      {currentUser.userType === "FRANCHISE_USER" && (
        <div className='row g-5 g-xl-8' style={{ marginTop: "10px" }}>

          {/* Left Side - Chart */}
          <div className="col-6">
            <SupplyChainGrowthChart
              title="Supply chain entities"
              subtitle="Monthly trend of number of household and Material Hub"
              className='card-xl-stretch mb-xl-8'
              customersData={null}
              suppliersData={data?.cumulativeUserTrend?.CUSTOMER || {}}
              facilitiesData={data?.cumulativeUserTrend?.PICKUP_POINT || {}}

            />
          </div>

          {/* Right Side - 4 Cards in 2x2 Grid */}
          <div className="col-6">
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
              <div>
                <TryWid
                  percentage={parseFloat(((data?.participationRate || 0) * 100).toFixed(1))}
                  title="Active Households"
                  chartColor="#4f45f5"
                  chartHeight="170px"
                  className="h-90"
                />
              </div>
              <div>
                <TryWid
                  percentage={parseFloat(((data?.pickupPointParticipationRate || 0) * 100).toFixed(1))}
                  title="Active Hubs"
                  chartColor="#ed6f43"
                  chartHeight="170px"
                  className="h-90"
                />
              </div>
              <div>
                <TryWid
                  percentage={parseFloat(((data?.recyclingRatio || 0) * 100).toFixed(1))}
                  title="Recycling ratio"
                  chartColor="#ffe500"
                  chartHeight="170px"
                  className="h-90"
                />
              </div>
              <div>
                <TryWid
                  percentage={parseFloat(((data?.transportationLossRatio || 0) * 100).toFixed(1))}
                  title="Transport loss"
                  chartColor="#4f45f5"
                  chartHeight="170px"
                  className="h-90"
                />
              </div>
            </div>
          </div>
        </div>
      )}









      {["FRANCHISE_USER", "CLIENT_USER", "MARKETING", "CLIENT"]?.includes(currentUser?.userType) && (
        <>
          <div style={{ display: 'flex', gap: '20px', margin: '10px 0' }}>
            <div style={{ flex: 1 }}>
              <SupplyChainGrowthChart
                title="Supply chain growth"
                subtitle=" Number of households, Material Hubs and Impact Partners added every month"
                className='card-xl-stretch mb-xl-8'
                chartHeight='365px'
                suppliersData={customerData?.monthlyCounts || {}}
                customersData={converterData?.monthlyCounts || {}}
                facilitiesData={pickupPointData?.monthlyCounts || {}}
              />
            </div>
            {/* <div style={{ flex: 1 }}>
              <ChartsWidget10 className='' data={data} />
            </div> */}
          </div>
          <div style={{ display: 'flex', gap: '20px', width: '100%', marginBottom: '20px' }}>

            {/* Left 50% - RecentOrders */}
            <div style={{ flex: 1 }}>
              <RecentOrders dashboardData={data} />
            </div>

            {/* Right 50% - Two cards side by side */}
            <div>
              <div style={{ flex: 1, display: 'flex', flexDirection: 'row', gap: '20px' }}>
                {data?.materialAnalytics?.breakup?.map((analytics: any, index: number) => (
                  <div style={{ flex: 1 }}>
                    <AverageDailySalesCard analytics={analytics} />
                  </div>
                ))}

              </div>
              {(currentUser?.userType === "CLIENT" || currentUser?.userType === "CLIENT_USER" || currentUser?.userType === "MARKETING") && (
                <div style={{ display: 'flex', gap: '20px', margin: '0', marginTop: "20px" }}>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <ChartsWidgetG3
                      className="card-xl-stretch mb-xl-8"
                      label=""
                      data={data.typeWiseCustomers}
                    />
                  </div>

                  <div style={{ flex: 1, minWidth: 0 }}>
                    <ChartsWidgetG4
                      className="card-xl-stretch mb-xl-8"
                      label=""
                      data={data.facilityWisePickupPoints}
                    />
                  </div>
                </div>
              )}

              {(currentUser?.userType === "CLIENT_USER" || currentUser?.userType === "MARKETING") && <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                <div>
                  <TryWid
                    percentage={parseFloat(((data?.participationRate || 0) * 100).toFixed(1))}
                    title="Active Households"
                    chartColor="#4f45f5"
                    chartHeight="170px"
                    className="h-90"
                  />
                </div>
                <div>
                  <TryWid
                    percentage={parseFloat(((data?.pickupPointParticipationRate || 0) * 100).toFixed(1))}
                    title="Active Hubs"
                    chartColor="#ed6f43"
                    chartHeight="170px"
                    className="h-90"
                  />
                </div>
              </div>}

              {(currentUser?.userType === "CLIENT") && <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                <div>
                  <TryWid
                    percentage={parseFloat(((data?.participationRate || 0) * 100).toFixed(1))}
                    title="Active Households"
                    chartColor="#4f45f5"
                    chartHeight="170px"
                    className="h-90"
                  />
                </div>
                <div>
                  <TryWid
                    percentage={parseFloat(((data?.pickupPointParticipationRate || 0) * 100).toFixed(1))}
                    title="Active Hubs"
                    chartColor="#ed6f43"
                    chartHeight="170px"
                    className="h-90"
                  />
                </div>
              </div>}

            </div>

          </div>
        </>
      )}

      {/* {currentUser?.userType === "FRANCHISE_USER" && (
        <div style={{ display: 'flex', justifyContent: 'space-between', margin: '10px 0' }}>
          <StatsCard
            icon="/media/svg/dashboard/New/recycling capacity.png"
            backgroundColor="#fae8fb"
            title={currentUser?.userType === 'FRANCHISE_USER' || currentUser?.userType === 'CLIENT'
              ? 'Manufacturing capacity (MT)'
              : 'Recycling capacity (MT)'}
            value={data?.diversionCapacities}
          />

          <StatsCard
            icon="/media/svg/dashboard/New/recycling factory.png"
            backgroundColor="#fad9cc"
            title="Recycling facility"
            value={data?.diversionFacilities}
          />

          <StatsCard
            icon="/media/svg/dashboard/New/waste supplier.png"
            backgroundColor="#fee9c0"
            title="Waste suppliers"
            value={data?.lifeImpacted}
          />

          <StatsCard
            icon="/media/svg/dashboard/New/Facilities.png"
            backgroundColor="#f5f3fe"
            title="Supply chain facilities"
            value={data?.collectionPoints}
          />
        </div>
      )} */}







      {currentUser?.userType === "CLIENT" && false && (
        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px', marginBottom: "20px" }}>
          {numberItems.map((eachitems, eachIndex) => {
            const images = [
              "/media/svg/dashboard/Production.png",
              "/media/svg/dashboard/stock-new.png",
              "/media/svg/dashboard/Customer.png",
              "/media/svg/dashboard/emission.png"
            ];

            const bgColors = [
              '#f5f3fe', // green for Production
              '#fee9c0', // teal for stock
              '#fad9cc', // yellow for Customer
              '#fae8fb'  // purple for emission
            ];

            return (
              <div key={eachIndex + 1 + ''} style={{
                margin: '10px',
                padding: '16px',
                borderRadius: '8px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                backgroundColor: '#ffffff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'start',
                flex: 1
              }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <div style={{
                    width: '48px',
                    height: '48px',
                    borderRadius: '50%',
                    backgroundColor: bgColors[eachIndex],
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '16px',
                    fontSize: '20px',
                    fontWeight: 'bold',
                    color: '#1a1a1a'
                  }}>
                    <img src={images[eachIndex]} alt="" style={{ width: '27px', height: '27px' }} />
                  </div>

                  <div style={{ textAlign: 'left' }}>
                    <div style={{ fontSize: '16px', fontWeight: '400' }}>{eachitems.name}</div>
                    <div style={{ fontSize: '24px', fontWeight: '700' }}>
                      {`${data[eachitems.value]?.toFixed(
                        [
                          'collectionPoints',
                          'diversionFacilities',
                          'wasteDiverters',
                          'lifeImpacted',
                        ].includes(eachitems.value)
                          ? 0
                          : 2
                      ) || ''}${['diversionFacilities', 'wasteDiverters', 'lifeImpacted', 'wastage'].includes(
                        eachitems.value
                      )
                        ? ''
                        : ' kg'
                        }`}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}














      {newDataMapLocation?.length && currentUser.userType === "FRANCHISE_USER" && (
        <div style={{ marginTop: "20px" }}>
          <TablesWidget18 className='mb-5 mb-xl-8' data={data} />
        </div>
      )}


      {/* {currentUser?.userType === "FRANCHISE_USER" && (
        <div style={{ marginTop: "35px" }}>
          <Item1 data={logsData} loading={loading} />
        </div>
      )} */}




      {(currentUser.userType === "FRANCHISE_USER") && false && (
        <div className="d-flex" style={{ gap: '16px', flex: 1, marginTop: "25px", flexWrap: 'nowrap' }}>
          {/* <div style={{ flex: 1, minWidth: 0 }}>
            <ChartsWidgetG
              className="mb-5"
              label=""
              data={data.diversionCapacitiesBreakdown}
            />
          </div> */}
          {/* <div style={{ flex: 1, minWidth: 0 }}>
            <MixedWidget7C1
              data={data.transportationLossRatio}
              title='Transportation loss'
              className='card-xl-stretch mb-xl-8'
              chartColor='success'
              chartHeight='200px'
              note="This data shows the percentage of materials lost while transportation"
            />
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <MixedWidget7C2
              data={data?.recyclingRatio}
              title='Recycling ratio'
              className='card-xl-stretch mb-xl-8'
              chartColor='success'
              chartHeight='200px'
              note="This data shows the percentage of materials being recycled into circular products"
            />
          </div> */}



        </div>
      )}









      {/* <div className='row g-xl-4' style={{ marginBottom: '20px', marginTop: '20px' }}>
        {numberItems.map((eachitems, eachIndex) => (
          <div key={eachIndex + 1 + ''} className='col-xl-3'>
            <StatisticsWidget5
              className='card-xl-stretch mb-xl-8'
              img={eachitems.icon}
              color={eachitems.color || 'warning'}
              iconColor='primary'
              title={`
             ${data[eachitems.value]?.toFixed(
                [
                  'collectionPoints',
                  'diversionFacilities',
                  'wasteDiverters',
                  'lifeImpacted',
                ].includes(eachitems.value)
                  ? 0
                  : 2
              ) || ''
                }
             ${['diversionFacilities', 'wasteDiverters', 'lifeImpacted', 'wastage'].includes(
                  eachitems.value
                )
                  ? ''
                  : ' kg'
                }
           `}
              description={eachitems.name}
            />
          </div>
        ))}
      </div> */}






















      {/* 

      <div className='row g-3 g-xl-8 mt-2'>
        <div className='col-xl-3'>
          <StatisticsWidget6
            className='card-xl-stretch mb-xl-8'
            color='success'
            title=''
            description='Recycling capacity (Metric Ton)'
            progress={data?.diversionCapacities || ''}
          />
        </div>

        <div className='col-xl-3'>
          <StatisticsWidget6
            className='card-xl-stretch mb-xl-8'
            color='warning'
            title=''
            description='Recycling facility'
            progress={data?.diversionFacilities || ''}
          />
        </div>
        <div className='col-xl-3'>
          <StatisticsWidget6
            className='card-xl-stretch mb-xl-8'
            color='primary'
            title=''
            description='Waste collector'
            progress={data?.lifeImpacted || ''}
          />
        </div>

        <div className='col-xl-3'>
          <StatisticsWidget6
            className='card-xl-stretch mb-xl-8'
            color='primary'
            title=''
            description='Supply chain facilities'
            progress={data?.collectionPoints || ''}
          />
        </div>
      </div> */}







      <div className='row g-5 g-xl-8'>
        <div className='col-xl-4'>
          <ListsWidget2 data={data?.topCustomers || {}} className='card-xl-stretch ' />
        </div>
        <div className='col-xl-4'>
          <ListsWidget2C title={"Top 5 Material Hubs"} data={data?.topPickupPoints || {}} className='card-xl-stretch ' />
          {/* <ListsWidget6 data={data?.pickupPoints || []} className='card-xl-stretch mb-5 mb-xl-8' /> */}
        </div>
        <div className='col-xl-4'>
          <ListsWidget2C data={data?.topEndCustomers || {}} className='card-xl-stretch ' />
          {/* <ListsWidget4
            data={data?.topEndCustomers || {}}
            className='card-xl-stretch mb-xl-8'
            items={5}
          /> */}
          {/* <TablesWidget5 data={characteristics || {}} className='card-xl-stretch mb-xl-8' /> */}
        </div>
      </div>


      <div className='row g-5 g-xl-8'>
        {/* <div className='col-xl-8'>
          {(sankey4.length > 1 && (
            <div className='card p-3'>
              <SankyWidget textAlign='left' label='Waste flow diagram' data={sankey4 || []} />
            </div>
          )) ||
            ''}
          <br />
        </div> */}



        {/* {(currentUser?.userType === "CLIENT") && (
          <div className='col-xl-4'>
            <ListsWidget4
              name='Top 5 Staff'
              data={topAppUsers?.data?.slice(0, 5)}
              className='card-xl-stretch mb-xl-8'
              items={5}
            />
          </div>
        )} */}
      </div>


      {(isSupplyChainManager && (
        <>
          <div className='row g-5 g-xl-8'>
            <div className='col-xl-6'>
              {/* <TablesWidget2
                linkTo='/apps/transactions/collect-orders'
                className='card-xl-stretch mb-5 mb-xl-8'
                cleanUpData={cleanUpData}
              /> */}
              {/* <TablesWidget10 data={cleanUpData} className='mb-5 mb-xl-8' /> */}
            </div>
            <div className='col-xl-6'>
              {/* <TablesWidget2Copy
                linkTo='/apps/transactions/items'
                className='card-xl-stretch mb-5 mb-xl-8'
                dispatchData={dispatchData}
              /> */}
              {/* <TablesWidget10 data={cleanUpData} className='mb-5 mb-xl-8' /> */}
            </div>
          </div>
        </>
      )) ||
        ''}
      {/* {!isSupplyChainManager && <TablesWidget10 data={cleanUpData} className='mb-5 mb-xl-8' />} */}











      {/* {!isSupplyChainManager && currentUser.userType !== 'CLIENT' && (
        <>
          <TablesWidget10 data={cleanUpData} className='mb-5 mb-xl-8' />
          <br />
        </>
      )} */}










      <br />
      {/* {!isSupplyChainManager && <TablesWidget13 data={dispatchData} className='mb-5 mb-xl-8' />} */}

      {/* {(currentUser?.userType === "CLIENT") && (
        <>
        <div style={{ marginBottom: "10px", width: "50%" }}>
          <ChartsWidget10 className='' data={data} />
        </div>
        <div style={{ marginBottom: "10px", width: "50%" }}>
          <div className="col-6">
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
              <div>
                <TryWid
                  percentage={
                    parseFloat(
                      data?.householdEngagement?.['2025-11']
                        ? (data.householdEngagement['2025-11'][1] * 100).toFixed(2)
                        : '0'
                    )
                  }
                  title="Active household"
                  chartColor="success"
                  chartHeight="170px"
                  className="h-90"
                />
              </div>
              <div>
                <TryWid
                  percentage={parseFloat(((data?.pickupPointParticipationRate || 0) * 100).toFixed(2))}
                  title="Active hubs"
                  chartColor="primary"
                  chartHeight="170px"
                  className="h-90"
                />
              </div>
              <div>
                <TryWid
                  percentage={parseFloat(((data?.recyclingRatio || 0) * 100).toFixed(2))}
                  title="Recycling ratio"
                  chartColor="warning"
                  chartHeight="170px"
                  className="h-90"
                />
              </div>
              <div>
                <TryWid
                  percentage={parseFloat(((data?.transportationLossRatio || 0) * 100).toFixed(2))}
                  title="Transport loss"
                  chartColor="info"
                  chartHeight="170px"
                  className="h-90"
                />
              </div>
            </div>
          </div>
        </div>
        </>
      )} */}
      {(currentUser?.userType === "CLIENT") && (
        <div style={{ display: 'flex', gap: '20px', marginBottom: '10px' }}>
          {/* Left side - ChartsWidget10 */}
          {/* <div style={{ width: '50%' }}>
            <ChartsWidget10 className='' data={data} height={280} />
          </div> */}

          {/* Right side - Grid of 4 widgets */}
          {/* <div style={{ width: '50%' }}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
              <div>
                <TryWid
                  percentage={
                    parseFloat(
                      data?.householdEngagement?.['2025-11']
                        ? (data.householdEngagement['2025-11'][1] * 100).toFixed(1)
                        : '0'
                    )
                  }
                  title="Active household"
                  chartColor="#4f45f5"
                  chartHeight="170px"
                  className="h-90"
                />
              </div>
              <div>
                <TryWid
                  percentage={parseFloat(((data?.pickupPointParticipationRate || 0) * 100).toFixed(1))}
                  title="Active hubs"
                  chartColor="#ed6f43"
                  chartHeight="170px"
                  className="h-90"
                />
              </div>
              <div>
                <TryWid
                  percentage={parseFloat(((data?.recyclingRatio || 0) * 100).toFixed(1))}
                  title="Recycling ratio"
                  chartColor="#ffe500"
                  chartHeight="170px"
                  className="h-90"
                />
              </div>
              <div>
                <TryWid
                  percentage={parseFloat(((data?.transportationLossRatio || 0) * 100).toFixed(1))}
                  title="Transport loss"
                  chartColor="#4f45f5"
                  chartHeight="170px"
                  className="h-90"
                />
              </div>
            </div>
          </div> */}
        </div>
      )}


      {(currentUser?.userType === "CLIENT_USER" || currentUser?.userType === "MARKETING") && (
        <div style={{ display: 'flex', gap: '20px', marginBottom: "30px" }}>
          {/* <div style={{ width: "50%" }}>
            <ChartsWidget10 className='' data={data} height={280} />
          </div> */}
          {/* <div style={{ width: "50%" }}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
              <div>
                <TryWid
                  percentage={parseFloat(((data?.participationRate || 0) * 100).toFixed(1))}
                  title="Active household"
                  chartColor="#4f45f5"
                  chartHeight="170px"
                  className="h-90"
                />
              </div>
              <div>
                <TryWid
                  percentage={parseFloat(((data?.pickupPointParticipationRate || 0) * 100).toFixed(1))}
                  title="Active hubs"
                  chartColor="#ed6f43"
                  chartHeight="170px"
                  className="h-90"
                />
              </div>
              <div>
                <TryWid
                  percentage={parseFloat(((data?.recyclingRatio || 0) * 100).toFixed(1))}
                  title="Recycling ratio"
                  chartColor="#ffe500"
                  chartHeight="170px"
                  className="h-90"
                />
              </div>
              <div>
                <TryWid
                  percentage={parseFloat(((data?.transportationLossRatio || 0) * 100).toFixed(1))}
                  title="Transport loss"
                  chartColor="#4f45f5"
                  chartHeight="170px"
                  className="h-90"
                />
              </div>
            </div>
          </div> */}
        </div>
      )}



      {!isSupplyChainManager && currentUser.userType !== 'CLIENT'
        && currentUser.userType !== 'CLIENT_USER' && currentUser.userType !== 'MARKETING'
        && (
          <TablesWidget9C className='mb-5 mb-xl-8' data={data2} loading={loading} />
        )}


      {isSupplyChainManager && (
        <div style={{ marginBottom: "20px" }}>
          <TablesWidget19
            className=''
            performanceData={performanceResponseData}
          />
        </div>
      )}





      {(currentUser?.userType === "CLIENT" || currentUser?.userType === "CLIENT_USER" || currentUser?.userType === "MARKETING") && (
        <>
          <div style={{ marginTop: "20px" }}>
            <TablesWidget18 className='mb-5 mb-xl-8' data={data} />
          </div>
        </>
      )}







      <div style={{ marginTop: "" }}>
        <div style={{ marginBottom: '20px' }}>
          <ChartsWidget3
            data={{ label: collectedGraphData.label, data: collectedGraphData?.data }}
            name='Collected from households'
            className='card-xl-stretch'
          />
        </div>
        <div style={{ marginBottom: '20px' }}>
          <ChartsWidget3
            data={{ label: processGraphData.label, data: processGraphData?.data }}
            name='Processed at MRF (kgs)'
            className='card-xl-stretch'
          />
        </div>
        <div style={{ marginBottom: '20px' }}>
          <ChartsWidget3
            data={{ label: suppliedGraphData.label, data: suppliedGraphData?.data }}
            name='Material transfer within supply chain (kg)'
            className='card-xl-stretch'
          />
        </div>
      </div>


      {/* {(currentUser?.userType === "FRANCHISE_USER" || currentUser?.userType === "CLIENT") && (
        // <TablesWidget9C className='mb-5 mb-xl-8' />
        <TablesWidget9C className='mb-5 mb-xl-8' data={data2} loading={loading} />
      )} */}



      {(currentUser?.userType === 'FRANCHISE_USER' || currentUser?.userType === 'CLIENT'
        || currentUser?.userType === "CLIENT_USER" || currentUser?.userType === "MARKETING"
      ) &&
        localStorage.getItem('kt-auth-react-v') &&
        JSON.parse(localStorage.getItem('kt-auth-react-v') || '{}')?.data?.segmentType === 'BIOFUEL' && (
          <TablesWidget9C className='mb-5 mb-xl-8' data={data2} loading={loading} />
        )}








    </>
  )
}

const DashboardWrapper: FC = () => {
  const intl = useIntl()
  const options = generateYearOptions(2015)

  const [selectedDate, setSelectedDate] = useState<any>('2026')
  return (
    <>
      <div className='flex justify-between items-center' style={{ marginTop: "-20px" }}>
        <div>
          <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.DASHBOARD' })}</PageTitle>
        </div>
        <div className='flex items-center space-x-2'>
          <select

            style={{
              backgroundColor: '#ffffff',
              border: '1px solid #dddddd',
              color: '#000000', // Text color for selected option
            }}

            className='form-select form-select-solid'
            data-kt-select2='true'
            data-placeholder='Select option'
            data-allow-clear='true'
            // defaultValue={'1'}
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
          >
            {/* {options.map(())} */}
            {options.map((eachOption, eachInd) => (
              <option key={eachInd + 1 + ''} value={eachOption.value}>
                {eachOption.label}
              </option>
            ))}
          </select>
          <button
            disabled={selectedDate === options[0].label}
            type='button'
            onClick={() => {
              setSelectedDate(options[0].label)
            }}
            // className='btn btn-sm '
            className='btn btn-secondary fw-bold px-6'
            data-kt-menu-dismiss='true'
          // style={{ background: "#ed6e43", color: "white" }}
          >
            Reset
          </button>
        </div>
      </div>
      <DashboardPage year={selectedDate} />






    </>
  )
}

export { DashboardWrapper }
